import { Routes } from '@angular/router'
import { FeatureType, RouteUtil } from '../shared'
import { SafetyMeetingsComponent } from './meetings/meetings.component'
import { AttendeeComponent } from './meetings/attendee.component'
import { JobHazardAnalysisComponent } from './job-hazard-analysis/job-hazard-analysis.component'
import { SafetyDashboardComponent } from './dashboard/safety-dashboard.component'
import { SubcontractorTrainingComponent } from './subcontractor-training/subcontractor-training.component'
import { VehicleInspectionComponent } from './vehicle-inspection/vehicle-inspection.component'
import { SafetyFeedbackPageComponent } from './safety-feedback/safety-feedback-page.component'
import { AutoAccidentReportPageComponent } from './auto-accident-report/auto-accident-report-page.component'
import { IncidentInvestigationComponent } from './incident-investigation/incident-investigation.component'
import { SafetyChecklistsComponent } from './safety-checklists/safety-checklists.component'

export const safetyRoutes: Routes = [
    {
        path: 'safety',
        children: [
            RouteUtil.Make('safety-meetings', SafetyMeetingsComponent, FeatureType.SafetyMeetingView),
            RouteUtil.Make('attendee', AttendeeComponent, null),
            RouteUtil.Make('dashboard', SafetyDashboardComponent, FeatureType.SafetyDashboardView),
            RouteUtil.Make('job-hazard-analysis', JobHazardAnalysisComponent, [
                FeatureType.SafetyJobHazardAnalysisView,
                FeatureType.SafetyJobHazardAnalysisDashboardView,
            ]),
            RouteUtil.Make('subcontractor-training', SubcontractorTrainingComponent, FeatureType.SubcontractorTrainingView),
            RouteUtil.Make('vehicle-inspection', VehicleInspectionComponent, FeatureType.SafetyVehicleInspectionView),
            RouteUtil.Make('safety-feedback', SafetyFeedbackPageComponent, [
                FeatureType.SafetyFeedbackView,
                FeatureType.SafetyFeedbackEdit,
            ]),
            RouteUtil.Make('auto-accident-report', AutoAccidentReportPageComponent, [
                FeatureType.SafetyAutoAccidentReportView,
                FeatureType.SafetyAutoAccidentReportDashboardView,
            ]),
            RouteUtil.Make('incident-investigation', IncidentInvestigationComponent, [
                FeatureType.SafetyIncidentInvestigationView,
                FeatureType.SafetyIncidentInvestigationDashboardView,
            ]),
            RouteUtil.Make('safety-checklists', SafetyChecklistsComponent, [
                FeatureType.SafetyChecklistView,
                FeatureType.SafetyChecklistDashboardView,
            ]),
        ],
    },
]
